import React from "react";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";


const GitchaZipCodeSubmiModal = (props) => {
  const { title, desc, show, onHide, handleSaveExit } = props;
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-custom-width"
      show={show}
    >
      <Modal.Body className="pt-32 pb-32">
        {/* <button
          type="button"
          class="btn-close"
          aria-label="Close"
          onClick={() => onHide()}
        ></button> */}
        <h3 className="text-start">
          {title || "We’ve received your request"}
        </h3>
        <p className="f-size-16 mb-4">
          {desc}
          {/* "We are diligently working to open up your area! Please type in the zip\n"
          "codes of where you need us, and we'll take it up with the bosses." */}
        </p>

     
        <div className="modal-btn-wrap">
          <Button variant="tertiary" className="btn me-3" onClick={()=> handleSaveExit()}>
            Save Draft And Exit
          </Button>

          <Button variant="primary" className="btn" onClick={()=> onHide()}>
            Close
          </Button>
        </div>
      </Modal.Body>
      {/*<Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>*/}
    </Modal>
  );
};
export default GitchaZipCodeSubmiModal;
